@if (showBanner) {
  <div class="cookie-banner">
    <p><strong>{{'COOKIEBANNER.TITLE' | translate}}</strong></p>
    <p>{{'COOKIEBANNER.MSG' | translate}}</p>

    <ion-button (click)="declineCookies()" color="medium">{{'COOKIEBANNER.DECLINE' | translate}}</ion-button>
    <ion-button (click)="acceptCookies()">{{'COOKIEBANNER.ACCEPT' | translate}}</ion-button>
  </div>
}
